import { Component, OnInit } from '@angular/core';
import { of, Subscription } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ControlUser } from '../model/controlUser';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  version: string = environment.onecontrol.version;
  username: string;
  emailAlias: string;
  userType: string;
  loggedUserSubscription: Subscription;
  userAliasType: string;

  constructor(private userService: UserService) {

    this.userAliasType = ControlUser.UserTypeAlias;
  }

  ngOnInit() {
  }

  ngAfterViewInit() {

    if (!this.username || this.username == "") {
      this.showUserInfo();
    }
  }

  showUserInfo() {

    this.userService.getFirebaseUserObs().pipe(
      filter(firebaseUser => !!firebaseUser), // Wait until the user is logged in
      switchMap(() => this.userService.getMe()), // Then call getMe()
      take(1) // Do this only once
    ).subscribe({
      next: (user) => {
        Log.debug("user: " + JSON.stringify(user));
    
        this.userType = user.userType;
    
        if (this.userType === this.userAliasType) {
          this.emailAlias = this.userService.getFirebaseEmail();
          this.username = this.emailAlias;
          this.userType = $localize`:@@footer_alias_of:Operatore di` + " " + user.username;
        } else {
          this.username = user.username;
        }
      },
      error: (errorRes) => {
        Log.debug("error cannot retrieve user");
        Log.debug(errorRes);
      }
    });
    
    
  }
}
